import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withLayoutService from './Layout.service';
import './Layout.css';
// import Menu, { MenuRight } from '../menu/Menu';
// import { Logo } from '../shared';

function Layout (props) {
  // const { partnerLogoId } = props;
  return (
    <main className="turing-ui-v2-main">
      {/* <header>
        <div className="turing-ui-v2-container-left">
          <Logo />
        </div>
        <div className="turing-ui-v2-container"><Menu active={props.active}/></div>
        <div className="turing-ui-v2-container-right">
          <MenuRight {...props}/>
        </div>
      </header> */}
      <div className={`turing-ui-v2-container ${props.className}`} style={{ width: '95%', maxWidth: props.width || 1200 }}>{props.children}</div>
      {/* <footer>
        {partnerLogoId ? null : <div className="turing-ui-v2-container">&copy; 2020 Turing Enterprises, Inc.</div>}
      </footer> */}
    </main>
  );
}

Layout.propTypes = {
  layoutService: PropTypes.instanceOf(Component).isRequired,
  userAvailability: PropTypes.any,
  children: PropTypes.any,
  active: PropTypes.any,
  partnerLogoId: PropTypes.any,
  width: PropTypes.any,
  className: PropTypes.string
};

export default withLayoutService(Layout);
